export default __webpack_public_path__ + "static/media/camera.7161c85f.svg";